module.exports = __webpack_public_path__ + "img/carshina22_18.a5354eec.jpg";